export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '内保单流水号',
            fixed: 'left',
            minWidth: 150
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'beginTime',
            label: '内保起期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '内保止期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'orgName',
            label: '出单机构',
            minWidth: 200
        },
        {
            prop: 'saleName',
            label: '业务员',
            minWidth: 100
        },
        {
            prop: 'cusFeeDiff',
            label: '应收差额（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'netFeeDiff',
            label: '净费差额（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'cashFeeDiff',
            label: '现金折扣差额（元）',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'createName',
            label: '制单人',
            minWidth: 100
        },
        {
            prop: 'createTime',
            label: '创建时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'auditName',
            label: '审核人',
            minWidth: 100
        },
        {
            prop: 'auditTime',
            label: '审核时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'fauditName',
            label: '财务审核',
            minWidth: 100
        },
        {
            prop: 'fauditTime',
            label: '财务审核时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'remark',
            label: '备注',
            minWidth: 100
        },
        {
            prop: 'real_pay_time',
            label: '实际支付时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'effect_time',
            label: '生效时间',
            sortable: true,
            minWidth: 200
        }
    ]
}

export default {}